<template>
    <div>
        <CCol sm="12">
            <CCard>
                <CCardBody class="d-flex flex-column">
                    <div class="d-flex mb-2 justify-content-end align-items-start">
                        <span class="flex-grow-1" v-if="name"><b>{{ $t('memberIntro') }}</b> {{ name }}</span>
                        <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                    </div>
                    <div class="d-flex flex-wrap">
                        <div role="group" class="form-group col-12">
                            <GalleryPicker class="gallery-picker" v-model="hero.image" :ratioWidth="16" :ratioHeight="9"
                                v-bind:class="{ 'is-invalid': genericValidator(hero.image) === false || errorValidator('Image') === false }"
                                :max="1"></GalleryPicker>
                        </div>
                        <div role="group" class="form-group col-12">
                            <label class=""> {{ $t('positionOptional') }}</label>
                            <CInput type="number" v-model="hero.position" :invalid-feedback="errorOutput['Position']"
                            :is-valid="errorValidator('Position')"></CInput>
                        </div>
                        <div role="group" class="form-group col-12 col-lg-6">
                            <label class=""> {{ $t('titleOptional') }}</label>
                            <CInput type="text" v-model="hero.titles[currentLanguage.key]"
                                :invalid-feedback="errorOutput['Titles']" :is-valid="errorValidator('Titles')"></CInput>
                        </div>
                        <div role="group" class="form-group col-12 col-lg-6">
                            <label class=""> {{ $t('contentOptional') }}</label>
                            <CInput type="text" v-model="hero.contents[currentLanguage.key]"
                                :invalid-feedback="errorOutput['Contents']" :is-valid="errorValidator('Contents')">
                            </CInput>
                        </div>
                        <div role="group" class="form-group col-12 col-lg-6">
                            <label class=""> {{ $t('buttonContentOptional') }}</label>
                            <CInput type="text" v-model="hero.buttonContents[currentLanguage.key]"
                                :invalid-feedback="errorOutput['ButtonContents']"
                                :is-valid="errorValidator('ButtonContents')"></CInput>
                        </div>
                        <div role="group" class="form-group col-12 col-lg-6">
                            <label class=""> {{ $t('buttonUrlOptional') }}</label>
                            <CInput type="text" v-model="hero.buttonUrl" :invalid-feedback="errorOutput['ButtonUrl']"
                                :is-valid="errorValidator('ButtonUrl')"></CInput>
                        </div>
                        <div role="group" class="form-group col-6 col-sm text-center mb-5">
                            <label :class="{'text-danger': triedSubmit && !hero.types.length}"> {{ $t('ageVerificationPage') }}</label>
                            <CInputCheckbox :checked="hero.types.includes('AgeVerification')" @update:checked="toggleType('AgeVerification')" :invalid-feedback="errorOutput['Type']" :is-valid="errorValidator('Type')"></CInputCheckbox>
                        </div>
                        <div role="group" class="form-group col-6 col-sm text-center mb-5">
                            <label :class="{'text-danger': triedSubmit && !hero.types.length}"> {{ $t('homeSlider') }}</label>
                            <CInputCheckbox :checked="hero.types.includes('HomeSlider')" @update:checked="toggleType('HomeSlider')" :invalid-feedback="errorOutput['Type']" :is-valid="errorValidator('Type')"></CInputCheckbox>
                        </div>
                        <div role="group" class="form-group col-6 col-sm text-center mb-5">
                            <label :class="{'text-danger': triedSubmit && !hero.types.length}"> {{ $t('homePage') }}</label>
                            <CInputCheckbox :checked="hero.types.includes('Home')" @update:checked="toggleType('Home')" :invalid-feedback="errorOutput['Type']" :is-valid="errorValidator('Type')"></CInputCheckbox>
                        </div>
                        <!-- <div role="group" class="form-group col-6 col-sm text-center mb-5">
                            <label :class="{'text-danger': triedSubmit && !hero.types.length}"> {{ $t('historyPage') }}</label>
                            <CInputCheckbox :checked="hero.types.includes('History')" @update:checked="toggleType('History')" :invalid-feedback="errorOutput['Type']" :is-valid="errorValidator('Type')"></CInputCheckbox>
                        </div> -->
                        <!-- <div role="group" class="form-group col-6 col-sm text-center mb-5">
                            <label :class="{'text-danger': triedSubmit && !hero.types.length}"> {{ $t('teamPage') }}</label>
                            <CInputCheckbox :checked="hero.types.includes('Team')" @update:checked="toggleType('Team')" :invalid-feedback="errorOutput['Type']" :is-valid="errorValidator('Type')"></CInputCheckbox>
                        </div> -->
                        <!-- <div role="group" class="form-group col-6 col-sm text-center mb-5">
                            <label :class="{'text-danger': triedSubmit && !hero.types.length}"> {{ $t('servicesPage') }}</label>
                            <CInputCheckbox :checked="hero.types.includes('Fleet')" @update:checked="toggleType('Fleet')" :invalid-feedback="errorOutput['Type']" :is-valid="errorValidator('Type')"></CInputCheckbox>
                        </div> -->
                        <div role="group" class="form-group col-6 col-sm text-center mb-5">
                            <label :class="{'text-danger': triedSubmit && !hero.types.length}"> {{ $t('winePage') }}</label>
                            <CInputCheckbox :checked="hero.types.includes('Wine')" @update:checked="toggleType('Wine')" :invalid-feedback="errorOutput['Type']" :is-valid="errorValidator('Type')"></CInputCheckbox>
                        </div>
                        <div role="group" class="form-group col-6 col-sm text-center mb-5">
                            <label :class="{'text-danger': triedSubmit && !hero.types.length}"> {{ $t('galleryPage') }}</label>
                            <CInputCheckbox :checked="hero.types.includes('Gallery')" @update:checked="toggleType('Gallery')" :invalid-feedback="errorOutput['Type']" :is-valid="errorValidator('Type')"></CInputCheckbox>
                        </div>
                        <div role="group" class="form-group col-6 col-sm text-center mb-5">
                            <label :class="{'text-danger': triedSubmit && !hero.types.length}"> {{ $t('contactPage') }}</label>
                            <CInputCheckbox :checked="hero.types.includes('Contact')" @update:checked="toggleType('Contact')" :invalid-feedback="errorOutput['Type']" :is-valid="errorValidator('Type')"></CInputCheckbox>
                        </div>
                    </div>
                    <div role="group" class="form-group col-12 d-flex justify-content-end">
                        <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                        <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                    </div>
                    <FormLoading v-if="loading"></FormLoading>
                </CCardBody>
            </CCard>
        </CCol>
        <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup"
            v-model="showConfirmationPopup"></ConfirmationPopUp>
    </div>
</template>

<script>
import { genericValidator, errorValidator, deepClone } from "@/helpers/utils.js";
import Hero from "@/classes/Hero";
import { mapState } from 'vuex';
import LanguageDropdown from "@/controls/LanguageDropdown.vue";
import { CONSTANTS } from '@/helpers/consts';
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import GalleryPicker from '@/controls/GalleryPicker.vue';
import FormLoading from '@/controls/FormLoading.vue';
import { API_HELPER } from "@/helpers/api.js";

export default {
    components: { LanguageDropdown, ConfirmationPopUp, GalleryPicker, FormLoading },
    props: {
        baseHero: {
            type: Object,
            default: null,
        },
        baseHeroName: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            triedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            hero: new Hero({}, {}, {}, []),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage: "",
        };
    },
    mounted() {
        this.resetHero();
    },
    computed: {
        ...mapState({
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput() {
            var result = [];
            if (this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput)) {
                result = this.alertOutput.reduce((accum, currentVal) => {
                    accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }
            return result;
        },
        ...mapState('heros', ['postHeroOutput']),
        ...mapState('heros', ['putHerosOutput']),
        name() {
            return this.baseHero || this.baseHeroName ? (this.baseHero ? this.baseHero.name : this.baseHeroName) : null;
        }
    },
    methods: {
        resetHero() {
            if (!this.baseHero) {
                var titles = {}, contents = {}, buttonContents = {};
                CONSTANTS.supportedLanguages.forEach(language => {
                    titles[language.key] = "";
                    contents[language.key] = "";
                    buttonContents[language.key] = "";
                });
                this.hero = new Hero(titles, contents, buttonContents, []);
            } else {
                this.hero = deepClone(new Hero(), this.baseHero);
                this.hero.image = { url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.hero.image]) };
            }
            // Ensure hero.types is initialized as an array of strings
            if (!this.hero.types) {
                this.hero.types = [];
            } else {
                this.hero.types = this.hero.types.map(type => type.type || type);
            }
        },
        toggleType(type) {
            const index = this.hero.types.indexOf(type);
            if (index > -1) {
                this.hero.types.splice(index, 1);
            } else {
                // Ensure only strings are added
                this.hero.types = this.hero.types.filter(t => typeof t === 'string');
                this.hero.types.push(type);
            }
            console.log('Updated types:', JSON.stringify(this.hero.types)); // Debug logging
        },
        submitClicked() {
            this.triedSubmit = true;
            if (this.hero.isValid()) {
                this.submitting = true;
                const payload = {
                    ...this.hero,
                    types: [...this.hero.types.filter(t => typeof t === 'string')] // Ensuring the types field is sent as an array of strings
                };
                console.log('Submitting payload:', JSON.stringify(payload)); // Debug logging
                this.$emit('submit-requested', payload);
            }
        },
        genericValidator,
        errorValidator,
        onClickConfirmationPopup(value) {
            this.showConfirmationPopup = value;
            this.$router.push({ name: "HerosList" });
        },
    },
    watch: {
        postHeroOutput(val) {
            if (val) {
                this.showConfirmationPopup = true;
            }
        },
        putHerosOutput(val) {
            if (val) {
                this.showConfirmationPopup = true;
            }
        },
        baseHero() {
            this.resetHero();
        },
        alertType() {
            this.submitting = false;
        },
        alertOutput() {
            this.submitting = false;
            if (typeof this.alertOutput === 'string' || this.alertOutput instanceof String) {
                alert(this.alertOutput);
            }
        }
    }
};
</script>

<style scoped>
.showDropdown {
    display: block !important;
}

.input-group-append {
    height: fit-content;
}

img {
    width: 50%;
    height: 50%;
}
</style>
